export default "__VITE_PUBLIC_ASSET__4aa9ba24__"